module.exports = "<div class=\"js-children-container crumbs_container\"></div>\n";